export const NEWS_STORAGE_KEYS = {
  ARTICLES: "mt6_vybe_news",
} as const;
